import {servicePath} from "./connectors/axios.services";
import {deleteAllCookies, deleteCookie, getCookie, setCookie} from "./connectors/cookies";
import {jwtDecode} from "jwt-decode";
import ReactGA from 'react-ga4';

export const register = async (data) => {
  const response = await servicePath.post('/users', {
    browser: data.browser,
    os: data.os,
    language: data.language
  });

  if (!response.data.token) {
    throw new Error("Missing token");
  }

  await setCookie('token', response.data.token, 1);

  const user = response.data.user;
  if (!user) {
    throw new Error("Missing user");
  }
  ReactGA.event({
    category: 'User',
    action: 'registered',
    label: 'User registered',
  });

  return user;
}

export const logout = async () => {
  deleteAllCookies(['cookies'])
  deleteCookie('token')
  ReactGA.event({
    category: 'User',
    action: 'logged_out',
    label: 'User logged out',
  });
}

export const getLoggedUserId = async () => {
  const token = getCookie('token');
  if (!token) {
    return null;
  }
  const dec = jwtDecode(token);
  return dec.sub
}